import { render, staticRenderFns } from "./report-templates.vue?vue&type=template&id=394d7a2e&scoped=true"
import script from "./report-templates.vue?vue&type=script&lang=js"
export * from "./report-templates.vue?vue&type=script&lang=js"
import style0 from "./report-templates.vue?vue&type=style&index=0&id=394d7a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394d7a2e",
  null
  
)

export default component.exports